import React, { useState, useEffect } from 'react';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import {
  checkAdminAuth,
  getAdminToken,
  adminLogout,
} from './services/apiService';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const ADMIN_LOGIN_TIME_KEY = 'metalbox_admin_login_time';
  const LOGIN_EXPIRY_MINUTES = 30;

  useEffect(() => {
    const checkAuth = async () => {
      console.log('🔄 App.jsx - 开始检查认证状态');
      console.log(
        '🔍 App.jsx - 当前 localStorage 中的 token:',
        localStorage.getItem('metalbox_admin_token')
      );
      console.log(
        '🔍 App.jsx - 当前 localStorage 中的登录时间:',
        localStorage.getItem('metalbox_admin_login_time')
      );

      const result = await checkAdminAuth();
      console.log('✅ App.jsx - 认证检查结果:', result);

      setIsAuthenticated(result.isAuthenticated);
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  // 监听用户活动以延长会话
  useEffect(() => {
    if (!isAuthenticated) return;

    const handleUserActivity = () => {
      const token = getAdminToken();
      if (token) {
        // 延长登录时间
        localStorage.setItem(ADMIN_LOGIN_TIME_KEY, Date.now().toString());
      }
    };

    // 监听用户交互事件（节流，每 5 秒最多触发一次）
    let throttleTimeout = null;
    const throttledUserActivity = () => {
      if (!throttleTimeout) {
        handleUserActivity();
        throttleTimeout = setTimeout(() => {
          throttleTimeout = null;
        }, 5000); // 5秒节流
      }
    };

    const events = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach((event) => {
      document.addEventListener(event, throttledUserActivity);
    });

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, throttledUserActivity);
      });
      if (throttleTimeout) clearTimeout(throttleTimeout);
    };
  }, [isAuthenticated]);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    adminLogout();
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#191c17]">
        <div className="text-center">
          <div className="inline-block">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#f5a623]"></div>
          </div>
          <p className="text-white mt-4">加载中...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? (
    <AdminDashboard onLogout={handleLogout} />
  ) : (
    <AdminLogin onLoginSuccess={handleLoginSuccess} />
  );
}

export default App;
